import React, { useEffect } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useFeatureIsOn, useGrowthBook } from "@growthbook/growthbook-react";

import { AuthStep } from "common/Auth/Auth.types";
import { useStore } from "store";

const Auth = dynamic(() => import("common/Auth/Auth"), { ssr: false });

type OAuthProviders = {
  yandex: "yandex";
};

export const providers: OAuthProviders = {
  yandex: "yandex",
};

export type OAuthProvider = keyof OAuthProviders;

const Oauth: React.FC = () => {
  const router = useRouter();
  const { user, notifications } = useStore();

  const gb = useGrowthBook();
  const yandexIdExperiment = useFeatureIsOn("ex_yandexid");

  const { query, replace, pathname } = router;
  const { code, provider, ...otherQueries } = query;

  const loginOAuth = async () => {
    const { data, errors } = await user.loginOAuth({
      code: code as string,
      provider: provider as OAuthProvider,
    });

    replace(
      {
        pathname,
        query: otherQueries,
      },
      undefined,
      { shallow: true }
    );

    if (errors) {
      notifications.show({
        type: "modal",
        component: Auth,
        props: {
          initialStep: AuthStep.OAUTH_FAILED,
          provider,
        },
      });

      return;
    }

    if (data?.loginOAuth?.session || !data?.loginOAuth.oauthUser) return;
    const { phone } = data.loginOAuth.oauthUser;

    notifications.show({
      type: "modal",
      component: Auth,
      props: {
        initialStep: phone ? AuthStep.STEP_2 : AuthStep.STEP_1,
        hideOAuthButtons: !phone,
        oauthUser: data.loginOAuth.oauthUser,
        oauthProvider: provider,
      },
    });
  };

  useEffect(() => {
    if (!gb?.ready || !yandexIdExperiment || !code || !provider) return;

    loginOAuth();
    // Unnecessary loginOAuth dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, yandexIdExperiment, gb?.ready]);

  return null;
};

export default Oauth;
